import type { ComponentType } from 'react'
import {
  Bot,
  CreditCard,
  FileText,
  Folder,
  Globe,
  House,
  Network,
  Search,
  Settings,
} from 'lucide-react'

export type RailItemKey =
  | 'home'
  | 'knowledge'
  | 'search'
  | 'graph'
  | 'published'
  | 'agents'
  | 'files'
  | 'billing'
  | 'settings'
  | 'profile'

export interface RailItem {
  key: RailItemKey
  label: string
  path: string
  icon: ComponentType<{ className?: string }>
  agent?: boolean
  shortcut?: string
}

export const PRIMARY_RAIL_ITEMS: RailItem[] = [
  { key: 'home', label: 'Home', path: '/', icon: House },
  { key: 'knowledge', label: 'Knowledge', path: '/doc', icon: FileText },
  { key: 'search', label: 'Search', path: '/search', icon: Search, shortcut: '⌘K' },
  { key: 'graph', label: 'Graph', path: '/graph', icon: Network },
  { key: 'published', label: 'Published Sites', path: '/sites', icon: Globe },
  { key: 'agents', label: 'Agents', path: '/agents', icon: Bot, agent: true },
]

export const SECONDARY_RAIL_ITEMS: RailItem[] = [
  { key: 'files', label: 'Files', path: '/storage', icon: Folder },
  { key: 'billing', label: 'Billing', path: '/billing', icon: CreditCard },
  { key: 'settings', label: 'Settings', path: '/settings', icon: Settings },
]
